import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CountryStateCityService {
  constructor(private readonly http: HttpClient) {}

  public getJSONCountry(): Observable<[] | {}> {
    return this.http.get('../assets/Json/Country.json');
  }

  public getStripeSupportedJSONCountry(): Observable<[] | {}> {
    return this.http.get('../assets/Json/StripeSupportedCountries.json');
  }

  public getUSJson(): Observable<[] | {}> {
    return this.http.get('../assets/Json/usCountry.json');
  }

  public getJSONStates(): Observable<[] | {}> {
    return this.http.get('../assets/Json/State.json');
  }

  public getJSONTimezone(): Observable<[] | {}> {
    return this.http.get('../assets/Json/time-zone.json');
  }

  public getTaxTypes(): Observable<[] | {}> {
    return this.http.get('../assets/Json/taxId.json');
  }

  public getJSONCityByState(stateName: string): Observable<[] | {}> {
    if (!stateName) {
      return of([]);
    }
    const formattedStateName = stateName.replace(/\s+/g, '_');
    return this.http.get(`./assets/Json/cities/${formattedStateName}.json`);
  }
}
